// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App.vue';

Vue.config.productionTip = false;

Vue.prototype.DEVELOPER = process.env.VUE_APP_DEVELOPER;
Vue.prototype.API_BASE = process.env.VUE_APP_API_BASE;
Vue.prototype.SCHEMA_STORAGE = process.env.VUE_APP_SCHEMA_STORAGE;
Vue.prototype.PAYPAL_CLIENT_ID = process.env.VUE_APP_PAYPAL_CLIENT_ID;
Vue.prototype.STRIPE_PUBLIC_KEY = process.env.VUE_APP_STRIPE_PUBLIC_KEY;

/* eslint-disable no-new */
new Vue({
  render: h => h(App),
}).$mount('#app');
